import Vue from "vue";
// @ts-ignore
import App from "./App.vue";
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "@/font/iconfont.css"
Vue.use(ElementUI);

// 粘贴板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 时间处理工具
import moment from 'moment'
Vue.prototype.$moment = moment

moment.locale('zh-cn') // 这里是进行了汉化 不写这句默认格式是外国的


//注册全局登录弹框
// @ts-ignore
import LoginDialog from './components/loginDialog/index.vue'
const loginDialog = new Vue(LoginDialog) 
loginDialog.$mount(document.createElement('div'))
document.body.appendChild(loginDialog.$el)
Vue.prototype.$loginDialog = loginDialog
export default loginDialog


Vue.config.productionTip = false;


new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
